<div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
        <div class="modal-body">
            <h5 class="title-step mt-0 mb-3 text-center text-black" *ngIf="title">{{ title }}</h5>
            <div class="mb-4">
                <p [innerHTML]="message" [class]="className"></p>
            </div>

            <div class="row" *ngIf="showAcceptButton">
                <div class="col-sm-6 offset-3">
                    <button class="btn d-block w-100 btn-orange text-white" (click)="close()">{{ acceptButtonText }}</button>
                </div>
            </div>
        </div>
    </div>
</div>
